import { createTheme } from '@mui/material/styles'

const COLOR_PRIMARY = '#0D47A1'
const COLOR_PRIMARY_LIGHT = '#388bff'
const COLOR_SECONDARY = '#E91E63'
const COLOR_BACKGROUND = '#F5F5F5'
const COLOR_PAPER = '#ffffeb'
const COLOR_SUCCESS = '#000000'
const COLOR_WARNING = '#000000'
const COLOR_INFO = '#000000'
const COLOR_ERROR = '#ff0000'
const COLOR_ERROR_LIGHT = '#D63921'

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: COLOR_PRIMARY,
      light: COLOR_PRIMARY_LIGHT,
    },
    secondary: {
      main: COLOR_SECONDARY,
    },
    background: {
      default: COLOR_BACKGROUND,
    },
    success: {
      main: COLOR_SUCCESS,
    },
    error: {
      main: COLOR_ERROR,
      light: COLOR_ERROR_LIGHT,
    },
    warning: {
      main: COLOR_WARNING,
    },
    info: {
      main: COLOR_INFO,
    },
  },
  typography: {
    fontFamily: `'Roboto'`,
    h1: {
      fontSize: `2.2rem`,
      fontWeight: 300,
      color: COLOR_PRIMARY,
      fontFamily: `'Poppins'`,
    },
    h2: {
      fontSize: `1.8rem`,
      fontFamily: `'Roboto'`,
      color: COLOR_PRIMARY,
    },
    h3: {
      fontSize: `1.6rem`,
      fontFamily: `'Roboto'`,
      color: COLOR_PRIMARY,
    },
    h4: {
      fontSize: `1.4rem`,
      fontWeight: 600,
      color: COLOR_PRIMARY,
    },
    h5: {
      fontSize: `1.3rem`,
      fontWeight: 600,
      color: COLOR_PRIMARY,
    },
    h6: {
      fontFamily: `'Roboto'`,
      fontWeight: 500,
      color: COLOR_PRIMARY,
    },
    body1: {
      fontFamily: `'Roboto'`,
    },
    button: {
      fontFamily: `'Roboto'`,
    },
    caption: {
      fontFamily: `'Roboto'`,
      fontSize: `0.8rem`,
    },
    overline: {
      fontSize: `0.8rem`,
    },
    body2: {
      fontFamily: `'Roboto'`,
    },
    subtitle1: {
      fontSize: `1rem`,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        container: {
          backdropFilter: 'blur(5px)',
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          backgroundColor: COLOR_BACKGROUND,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: COLOR_PRIMARY_LIGHT,
        },
      },
    },
  },
})
